/**
 * El rechazo de una exportación demasiado grande, compartido por las TRES
 * pantallas que exportan: las dos de consumos y la de cargas de salida.
 *
 * Nació el 2026-10-14: las dos llamadas a `getConsumosExport` tenían
 * `try { … } finally { setExporting(false) }` **sin `catch`**. Con el endpoint
 * devolviendo siempre 200 eso no se notaba; desde que puede rechazar con 413, un
 * fallo dejaría el botón como si nada hubiera pasado y el usuario volvería a
 * pulsarlo sin saber por qué no se descarga nada. Un error que no se pinta es
 * peor que el error.
 */
import { useTranslation } from 'react-i18next'
import type { AxiosError } from 'axios'

export interface ErrorExport {
  codigo: string
  valores?: Record<string, unknown>
}

/** Extrae `{codigo, valores}` del 413, con un código genérico de reserva.
 *  Misma forma que `errorComentarioDe` / `errorMuelleDe`. */
export function errorExportDe(err: unknown): ErrorExport {
  const detalle = (err as AxiosError<{ detail?: ErrorExport }>)?.response?.data?.detail
  if (detalle && typeof detalle.codigo === 'string') return detalle
  return { codigo: 'error_inesperado' }
}

/** El aviso, en línea junto al botón. */
export function AvisoExport({ error, dark }: { error: ErrorExport | null; dark: boolean }) {
  const { t } = useTranslation()
  if (!error) return null
  return (
    <span
      role="alert"
      className={`text-[11px] font-medium px-2 py-1 rounded-lg ${
        dark ? 'bg-red-500/15 text-red-300' : 'bg-red-100 text-red-700'
      }`}
    >
      {t(`export.errores.${error.codigo}`, {
        defaultValue: t('export.errores.error_inesperado'),
        ...(error.valores ?? {}),
      })}
    </span>
  )
}
